import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { publishedBooks } from '../mockData';
import { BookOpen, ExternalLink, Send, User, Mail, Phone } from 'lucide-react';
import { sendEmail } from '../services/emailService';

const Books = () => {
  const [activeTab, setActiveTab] = useState('published');
  const [formData, setFormData] = useState({
    name: '',
    designation: '',
    paperTitle: '',
    whatsapp: '',
    mobile: '',
    email: ''
  });

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const result = await sendEmail(formData, 'chapter');
    
    if (result.success) {
      alert(result.message);
      setFormData({ name: '', designation: '', paperTitle: '', whatsapp: '', mobile: '', email: '' });
    } else {
      alert(result.message);
    }
  };

  return (
    <div style={{ backgroundColor: 'var(--bg-page)', minHeight: '100vh' }}>
      {/* Hero Section */}
      <section className="hero-section text-center" style={{ 
        background: 'linear-gradient(135deg, rgba(30, 64, 175, 0.9), rgba(59, 130, 246, 0.9)), url("https://images.unsplash.com/photo-1481627834876-b7833e8f5570?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80")',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}>
        <div className="container-custom">
          <h1 className="heading-1 text-white mb-6" style={{color:"White"}}>Books & Publications</h1>
          <p className="body-large text-white mb-8" style={{ maxWidth: '600px', margin: '0 auto 2rem', opacity: 0.95, color: "#f6862a" }}>
            Explore our collection of academic publications and opportunities to contribute to future editions
          </p>
        </div>
      </section>

      <div className="container-custom" style={{ padding: '80px 24px' }}>
        {/* Tab Navigation */}
        <div style={{ display: 'flex', gap: '16px', marginBottom: '48px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={() => setActiveTab('published')}
            style={{
              padding: '12px 32px',
              borderRadius: '25px',
              border: activeTab === 'published' ? 'none' : '2px solid var(--brand-primary)',
              backgroundColor: activeTab === 'published' ? 'var(--brand-primary)' : 'transparent',
              color: activeTab === 'published' ? 'Green' : 'var(--brand-primary)',
              cursor: 'pointer',
              fontWeight: 600,
              fontSize: '1rem',
              transition: 'all 0.3s ease',
            }}
          >
            Published Books
          </button>
          <button
            onClick={() => setActiveTab('upcoming')}
            style={{
              padding: '12px 32px',
              borderRadius: '25px',
              border: activeTab === 'upcoming' ? 'none' : '2px solid var(--brand-primary)',
              backgroundColor: activeTab === 'upcoming' ? 'var(--brand-primary)' : 'transparent',
              color: activeTab === 'upcoming' ? 'Green' : 'var(--brand-primary)',
              cursor: 'pointer',
              fontWeight: 600,
              fontSize: '1rem',
              transition: 'all 0.3s ease',
            }}
          >
            Upcoming Book Chapters
          </button>
          <Link to="/books/publish" style={{ textDecoration: 'none' }}>
            <button style={{
              padding: '12px 32px',
              borderRadius: '25px',
              border: 'none',
              backgroundColor: '#28a745',
              color: 'white',
              cursor: 'pointer',
              fontWeight: 600,
              fontSize: '1rem',
              transition: 'all 0.3s ease',
            }}>
              Publish a Book
            </button>
          </Link>
        </div>

        {/* Published Books */}
        {activeTab === 'published' && (
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <h2 className="heading-2" style={{ textAlign: 'center', marginBottom: '50px', color: 'var(--brand-primary)' }}>Published Books</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '40px' }}>
              {publishedBooks.map((book) => (
                <div
                  key={book.id}
                  style={{
                    backgroundColor: 'var(--bg-card)',
                    borderRadius: '16px',
                    overflow: 'hidden',
                    border: '1px solid var(--border-medium)',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                    transition: 'transform 0.3s ease',
                    cursor: 'pointer',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-8px)')}
                  onMouseLeave={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
                >
                  <div style={{ height: '400px', overflow: 'hidden', backgroundColor: 'var(--bg-page)' }}>
                    <img src={book.cover} alt={book.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  </div>
                  <div style={{ padding: '30px' }}>
                    <h3 style={{ color: 'var(--text-primary)', fontSize: '1.3rem', fontWeight: 700, marginBottom: '15px', lineHeight: '1.3' }}>
                      {book.title}
                    </h3>
                    <p style={{ marginBottom: '10px', fontSize: '1rem', color: 'var(--text-secondary)' }}>
                      <strong>Editor:</strong> {book.editor}
                    </p>
                    <p style={{ fontSize: '0.9rem', color: 'var(--text-muted)' }}>
                      <strong>ISBN:</strong> {book.isbn}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Upcoming Book Chapters */}
        {activeTab === 'upcoming' && (
          <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
            <h2 className="heading-2" style={{ textAlign: 'center', marginBottom: '50px', color: 'var(--brand-primary)' }}>Upcoming Book Chapters</h2>
            
            {/* Book Opportunities */}
            <div style={{ display: 'grid', gap: '30px', marginBottom: '60px' }}>
              <div style={{ backgroundColor: 'var(--bg-card)', padding: '40px', borderRadius: '16px', border: '1px solid var(--border-medium)', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '30px' }}>
                  <div>
                    <h4 style={{ color: 'var(--brand-primary)', fontSize: '0.9rem', fontWeight: 600, marginBottom: '8px' }}>BOOK NAME</h4>
                    <p style={{ color: 'var(--text-primary)', fontWeight: 600, fontSize: '1.1rem' }}>Future of Education 2025</p>
                  </div>
                  <div>
                    <h4 style={{ color: 'var(--brand-primary)', fontSize: '0.9rem', fontWeight: 600, marginBottom: '8px' }}>EDITOR</h4>
                    <p style={{ color: 'var(--text-primary)', fontWeight: 600, fontSize: '1.1rem' }}>Dr. Anand Kumar</p>
                  </div>
                  <div>
                    <h4 style={{ color: 'var(--brand-primary)', fontSize: '0.9rem', fontWeight: 600, marginBottom: '8px' }}>CATEGORY</h4>
                    <p style={{ color: 'var(--text-primary)', fontWeight: 600, fontSize: '1.1rem' }}>Education</p>
                  </div>
                  <div>
                    <h4 style={{ color: 'var(--brand-primary)', fontSize: '0.9rem', fontWeight: 600, marginBottom: '8px' }}>ISBN</h4>
                    <p style={{ color: 'var(--text-primary)', fontWeight: 600, fontSize: '1.1rem' }}>978-93-90781-15-7</p>
                  </div>
                </div>
              </div>

              <div style={{ backgroundColor: 'var(--bg-card)', padding: '40px', borderRadius: '16px', border: '1px solid var(--border-medium)', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '30px' }}>
                  <div>
                    <h4 style={{ color: 'var(--brand-primary)', fontSize: '0.9rem', fontWeight: 600, marginBottom: '8px' }}>BOOK NAME</h4>
                    <p style={{ color: 'var(--text-primary)', fontWeight: 600, fontSize: '1.1rem' }}>Artificial Intelligence in Research</p>
                  </div>
                  <div>
                    <h4 style={{ color: 'var(--brand-primary)', fontSize: '0.9rem', fontWeight: 600, marginBottom: '8px' }}>EDITOR</h4>
                    <p style={{ color: 'var(--text-primary)', fontWeight: 600, fontSize: '1.1rem' }}>Prof. Lakshmi Iyer</p>
                  </div>
                  <div>
                    <h4 style={{ color: 'var(--brand-primary)', fontSize: '0.9rem', fontWeight: 600, marginBottom: '8px' }}>CATEGORY</h4>
                    <p style={{ color: 'var(--text-primary)', fontWeight: 600, fontSize: '1.1rem' }}>Technology</p>
                  </div>
                  <div>
                    <h4 style={{ color: 'var(--brand-primary)', fontSize: '0.9rem', fontWeight: 600, marginBottom: '8px' }}>ISBN</h4>
                    <p style={{ color: 'var(--text-primary)', fontWeight: 600, fontSize: '1.1rem' }}>978-93-90781-16-4</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Submission Form */}
            <div style={{ 
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
              padding: '3px', 
              borderRadius: '20px', 
              boxShadow: '0 8px 32px rgba(102, 126, 234, 0.3)' 
            }}>
              <div style={{ 
                backgroundColor: 'white', 
                padding: '50px', 
                borderRadius: '17px'
              }}>
                <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                  <div style={{
                    display: 'inline-block',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    padding: '12px 30px',
                    borderRadius: '25px',
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    marginBottom: '15px'
                  }}>
                    📚 CHAPTER SUBMISSION
                  </div>
                  <h3 style={{ color: '#4a5568', fontSize: '2rem', fontWeight: 700, margin: 0 }}>Submit Your Chapter</h3>
                  <p style={{ color: '#718096', fontSize: '1.1rem', marginTop: '10px' }}>Join thousands of researchers worldwide</p>
                </div>
                
                <form onSubmit={handleSubmit} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '25px' }}>
                  <div>
                    <label style={{ display: 'block', color: '#2d3748', fontSize: '1rem', fontWeight: 600, marginBottom: '10px' }}>👤 Name *</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                      style={{
                        width: '100%',
                        padding: '15px 20px',
                        backgroundColor: '#f7fafc',
                        border: '2px solid #e2e8f0',
                        borderRadius: '12px',
                        fontSize: '1rem',
                        transition: 'all 0.3s ease',
                        outline: 'none'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#667eea'}
                      onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                    />
                  </div>

                  <div>
                    <label style={{ display: 'block', color: '#2d3748', fontSize: '1rem', fontWeight: 600, marginBottom: '10px' }}>🎓 Designation *</label>
                    <input
                      type="text"
                      name="designation"
                      value={formData.designation}
                      onChange={handleInputChange}
                      required
                      style={{
                        width: '100%',
                        padding: '15px 20px',
                        backgroundColor: '#f7fafc',
                        border: '2px solid #e2e8f0',
                        borderRadius: '12px',
                        fontSize: '1rem',
                        transition: 'all 0.3s ease',
                        outline: 'none'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#667eea'}
                      onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                    />
                  </div>

                  <div style={{ gridColumn: '1 / -1' }}>
                    <label style={{ display: 'block', color: '#2d3748', fontSize: '1rem', fontWeight: 600, marginBottom: '10px' }}>📄 Paper Title *</label>
                    <input
                      type="text"
                      name="paperTitle"
                      value={formData.paperTitle}
                      onChange={handleInputChange}
                      required
                      style={{
                        width: '100%',
                        padding: '15px 20px',
                        backgroundColor: '#f7fafc',
                        border: '2px solid #e2e8f0',
                        borderRadius: '12px',
                        fontSize: '1rem',
                        transition: 'all 0.3s ease',
                        outline: 'none'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#667eea'}
                      onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                    />
                  </div>

                  <div>
                    <label style={{ display: 'block', color: '#2d3748', fontSize: '1rem', fontWeight: 600, marginBottom: '10px' }}>💬 WhatsApp Number *</label>
                    <input
                      type="tel"
                      name="whatsapp"
                      value={formData.whatsapp}
                      onChange={handleInputChange}
                      required
                      style={{
                        width: '100%',
                        padding: '15px 20px',
                        backgroundColor: '#f7fafc',
                        border: '2px solid #e2e8f0',
                        borderRadius: '12px',
                        fontSize: '1rem',
                        transition: 'all 0.3s ease',
                        outline: 'none'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#667eea'}
                      onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                    />
                  </div>

                  <div>
                    <label style={{ display: 'block', color: '#2d3748', fontSize: '1rem', fontWeight: 600, marginBottom: '10px' }}>📱 Mobile Number *</label>
                    <input
                      type="tel"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleInputChange}
                      required
                      style={{
                        width: '100%',
                        padding: '15px 20px',
                        backgroundColor: '#f7fafc',
                        border: '2px solid #e2e8f0',
                        borderRadius: '12px',
                        fontSize: '1rem',
                        transition: 'all 0.3s ease',
                        outline: 'none'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#667eea'}
                      onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                    />
                  </div>

                  <div style={{ gridColumn: '1 / -1' }}>
                    <label style={{ display: 'block', color: '#2d3748', fontSize: '1rem', fontWeight: 600, marginBottom: '10px' }}>📧 Email *</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      style={{
                        width: '100%',
                        padding: '15px 20px',
                        backgroundColor: '#f7fafc',
                        border: '2px solid #e2e8f0',
                        borderRadius: '12px',
                        fontSize: '1rem',
                        transition: 'all 0.3s ease',
                        outline: 'none'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#667eea'}
                      onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                    />
                  </div>

                  <div style={{ gridColumn: '1 / -1', textAlign: 'center', marginTop: '30px' }}>
                    <button type="submit" style={{
                      padding: '18px 50px',
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '30px',
                      fontSize: '1.1rem',
                      fontWeight: 700,
                      cursor: 'pointer',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '12px',
                      transition: 'all 0.3s ease',
                      boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
                      textTransform: 'uppercase',
                      letterSpacing: '1px'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.6)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.4)';
                    }}>
                      <Send size={20} />
                      Submit Chapter
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Books;